import { useEffect, useState } from "react";
import { useTabContext } from "../context";

export const useInitialTab = initialTab => {
  const { activeTabId, setActiveTabId, tabList } = useTabContext();
  const [hasSet, setHasSet] = useState(false);

  useEffect(() => {
    if (tabList.length <= 0 || hasSet || activeTabId) {
      return;
    }

    if (initialTab) {
      setActiveTabId(initialTab);
    } else {
      setActiveTabId(tabList[0].tabId);
    }

    setHasSet(true);
  }, [initialTab, activeTabId, setActiveTabId, tabList, hasSet, setHasSet]);
};